import { render } from "./PhotoUpload.vue?vue&type=template&id=34e4943f&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"

import "./PhotoUpload.vue?vue&type=style&index=0&id=34e4943f&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e4943f"]])

export default __exports__